import { render, staticRenderFns } from "./RouterMenu.vue?vue&type=template&id=4e2e0df9&scoped=true"
import script from "./RouterMenu.vue?vue&type=script&lang=js"
export * from "./RouterMenu.vue?vue&type=script&lang=js"
import style0 from "./RouterMenu.vue?vue&type=style&index=0&id=4e2e0df9&prod&lang=scss&scoped=true"
import style1 from "./RouterMenu.vue?vue&type=style&index=1&id=4e2e0df9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_css-loader@6.11.0_webpack@5.104.1_cssnano@5_665be98a8828166c9882e9000b2a540b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2e0df9",
  null
  
)

export default component.exports